const optionsComponent = require('../optionsComponent/optionsComponent');

const selectMultiple = Object.assign({}, optionsComponent, {
    subelements: {
        selectAll: false,
        selectNone: false
    },
    tagify: false,

    init: function () {
        optionsComponent.init.call(this);

        this.selectedValue = String(this.selectedValue).split(',');

        this.options.forEach((option) => {
            if (typeof option.id === 'number') {
                option.id = option.id.toString();
            }
        });

        this.initTagify();

        if (this.subelements.selectAll !== false) {
            this.subelements.selectAll.addEventListener('click', (e) => { e.preventDefault(); this.selectAll(); });
        }

        if (this.subelements.selectNone !== false) {
            this.subelements.selectNone.addEventListener('click', (e) => { e.preventDefault(); this.selectNone(); });
        }
    },

    initTagify: function () {
        let whiteList = [];

        this.options.forEach((option) => {
            let whiteListItem = { value: option.id, name: option.name };
            whiteList.push(whiteListItem);
        });

        let tagifyConfigs = {
            tagTextProp: 'name',
            whitelist: whiteList,
            //userInput: false,
            enforceWhitelist: true,
            dropdown: {
                closeOnSelect: false,
                enabled: 0,
                maxItems: 20,
                searchKeys: ['name'],
                mapValueTo: (data) => { return String(data.name); }
            },
            /*
            templates: {
                tag: (tagData, tagify) => {
                    let tagHTML = '<tag class="'+tagify.settings.classNames.tag + '" contenteditable="false" spellcheck="false"><x title="" class="'+tagify.settings.classNames.tagX+'" role="button" aria-label="remove tag"></x><div><span>' + tagData.name + '</span></div></tag>';
                    return tagHTML;
                },
            },*/
            /**/
            transformTag: (tagData, originalData) => {
                let found = false;
                for (let i = 0; i < this.options.length; i++) {
                    if (String(tagData.value) === this.options[i].id) {
                        found = this.options[i];
                        break;
                    }
                }

                if (found !== false) {
                    tagData.name = found.name;
                } else {
                    tagData.name = '-- not found --';
                }
            },
            originalInputValueFormat: valuesArr => valuesArr.map(item => item.value).join(',')
        };

        this.tagify = new Tagify(this.element, tagifyConfigs);
    },

    getValue: function () {
        if (this.isHidden && this.hiddenValue !== false) {
            return this.hiddenValue;
        }
        
        if (this.tagify !== false) {
            this.selectedValue = [];

            this.tagify.value.forEach((selectedValue) => {
                this.selectedValue.push(selectedValue.value);
            });
        }

        return this.selectedValue;
    },

    selectAll: function () {
        this.tagify.dropdown.selectAll();
    },

    selectNone: function () {
        this.tagify.removeAllTags();
    }
});

module.exports = selectMultiple;